import { FC } from 'react';

import { Icon, Pressable } from '@rbilabs/universal-components';

import { RotateAnimatedView } from 'components/ucl';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { DisplayToggleProps } from './types';

export const DisplayToggle: FC<DisplayToggleProps> = ({
  collapsed,
  onPress,
  isDisabled = false,
}) => {
  const expanded = !collapsed;
  const icon: React.JSX.Element | null = !isDisabled ? (
    <Icon
      variant="select"
      color={primitive.$bbqBrown}
      width="24px"
      {...hiddenAccessibilityPlatformProps}
    />
  ) : null;

  return (
    <Pressable
      isDisabled={isDisabled}
      testID="display-toggle-payment-method"
      accessibilityLabel="Toggle to select payment method"
      accessibilityRole="button"
      onPress={onPress}
    >
      <RotateAnimatedView isRotated={expanded}>{icon}</RotateAnimatedView>
    </Pressable>
  );
};
